// ====================================================
// More Templates: https://www.ebenmonney.com/templates
// Email: support@ebenmonney.com
// ====================================================

import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, map, mergeMap, catchError, switchMap } from 'rxjs';
import { Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';


@Injectable()
export class EndpointFactory {

    static readonly apiVersion: string = "1";

    private readonly _loginUrl: string = "/connect/token";

    private get loginUrl() { return this.configurations.baseUrl + this._loginUrl; }



    private taskPauser: Subject<any>;
    private isRefreshingLogin: boolean;

    private _authService: AuthService;

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }



    constructor(protected http: HttpClient, protected configurations: ConfigurationService, private injector: Injector) {

    }


    getLoginEndpoint<T>(userName: string, password: string): Observable<T> {

        let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        console.log("password: " + password);
        let params = new HttpParams()
            .append('username', userName)
            .append('password', encodeURIComponent(password))
            .append('grant_type', 'password')
            .append('client_id', 'se_conf_fe')
            .append('client_secret','901564A5-E7FE-42AB-B10D-61EF6A8F3654')
            //.append('response_type', 'id_token')
            //.append('nonce', '1234')
            //.append('redirect_uri', window.location.origin + '/')
            .append('scope', 'openid offline_access roles email')//email phone profile roles
            .append('claim', 'role')
            ;
        
        let requestBody = params.toString();
        console.log("requestBody: " + requestBody);
        return this.http.post<T>(this.loginUrl, requestBody, { headers: header });
    }


    getRefreshLoginEndpoint<T>(): Observable<T> {

        let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

        let params = new HttpParams()
            .append('refresh_token', this.authService.refreshToken)
            .append('grant_type', 'refresh_token')
            .append('scope', 'openid email phone profile offline_access roles');

        let requestBody = params.toString();

        var res;
        this.http.post<T>(this.loginUrl, requestBody, { headers: header })
            .subscribe(
                result => {
                    res = result;
                }, error => {
                    return this.handleError(error, () => this.getRefreshLoginEndpoint());
                }
            );
        return res;
        /*
        return this.http.post<T>(this.loginUrl, requestBody, { headers: header })
            .catch(error => {
                return this.handleError(error, () => this.getRefreshLoginEndpoint());
            });
            */
    }



    protected getRequestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
        let headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.authService.accessToken,
            'Content-Type': 'application/json',
            'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
            'App-Version': ConfigurationService.appVersion
        });

        return { headers: headers };
    }



    protected handleError(error, continuation: () => Observable<any>) {

        if (error.status == 401) {
            if (this.isRefreshingLogin) {
                return this.pauseTask(continuation);
            }

            this.isRefreshingLogin = true;

            return this.authService.refreshLogin()
                .pipe(mergeMap(data => {
                    this.isRefreshingLogin = false;
                    this.resumeTasks(true);

                    return continuation();
                }))
                .pipe(catchError(refreshLoginError => {
                    this.isRefreshingLogin = false;
                    this.resumeTasks(false);

                    if (refreshLoginError.status == 401 || (refreshLoginError.url && refreshLoginError.url.toLowerCase().includes(this.loginUrl.toLowerCase()))) {
                        this.authService.reLogin();
                        return throwError(()=>new Error('session expired'));
                    }
                    else {
                        return throwError(()=>new Error(refreshLoginError || 'server error'));
                    }
                }));
        }

        if (error.url && error.url.toLowerCase().includes(this.loginUrl.toLowerCase())) {
            this.authService.reLogin();

            return throwError(()=>new Error((error.error && error.error.error_description) ? `session expired (${error.error.error_description})` : 'session expired'));
        }
        else {
            return throwError(()=>new Error(error || 'server error'));
        }
    }



    private pauseTask(continuation: () => Observable<any>) {
        if (!this.taskPauser)
            this.taskPauser = new Subject();

        return this.taskPauser.pipe(
            switchMap(continueOp => {
                return continueOp ? continuation() : throwError(()=>new Error('session expired'));
            })
            );
    }


    private resumeTasks(continueOp: boolean) {
        setTimeout(() => {
            if (this.taskPauser) {
                this.taskPauser.next(continueOp);
                this.taskPauser.complete();
                this.taskPauser = null;
            }
        });
    }
}
